<footer style="margin-top:-200px">
  <div class="row">
    <div class="col-md-11">

      <!--p class="pull-left"-->
     
      © 2023 Dubai Electricity and Water Authority. All Rights Reserved. The site is best viewed using IE 11 and above, Mozilla Firefox, Safari and Chrome.
      <!--/p-->
    </div>
    
  </div>
  <!--div class="clearfix"></div-->
</footer>